import consumer from "./consumer"

let connectionSubscription;
document.addEventListener("DOMContentLoaded", () => {
    const userId = parseInt(document.querySelector("meta[name='current-user-id']").content)

    connectionSubscription = consumer.subscriptions.create(
        {channel: "ConnectionsChannel", user_id: userId},
        {
            connected() {
                // this.pingInterval = setInterval(() => this.perform("ping"), 30000);
            },

            disconnected() {
                // clearInterval(this.pingInterval);
            },
        });

});